import axios, { AxiosRequestConfig, AxiosInstance } from 'axios';
import { store } from '../store/store';
import { logoutReducer } from '../store/reducers/authReducer';
import { setSession } from '../utils/jwt';
import { HOST_API, getHostApi } from '../config';

const BASE_URL = HOST_API || '';

const apiConfig: AxiosRequestConfig = {
  timeout: 1200000,
  headers: {
    'Content-Type': 'application/json',
    'Accept': '*/*',
  },
};

const axiosInstance: AxiosInstance = axios.create({ baseURL: BASE_URL, ...apiConfig });

axiosInstance.interceptors.request.use(
  (config) => {
    config.baseURL = getHostApi();
    let token = store.getState().auth.accessToken;
    if (!token && typeof window !== 'undefined') {
      token = localStorage.getItem('accessToken');
    }
    if (config.headers) {
      config.headers['ngrok-skip-browser-warning'] = 'true';
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// The owner's token lasts 1 hour and there is no refresh endpoint: on any 401
// the token is dropped and the owner is sent back to the login screen. A 401
// from the login steps themselves (wrong password / code, expired login step)
// is handled by the login form. /owner/login-history is not a login step.
const LOGIN_STEP_URLS = ['/owner/login', '/owner/login/verify'];

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const { config, response } = error;
    const url = (config?.url || '').split('?')[0];
    if (response?.status === 401 && !LOGIN_STEP_URLS.includes(url)) {
      setSession(null);
      store.dispatch(logoutReducer());
      if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/auth/login')) {
        window.location.href = '/auth/login';
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
